export const FeatureFlagIdByName = {
  CarrierMatching: '0F114BA2-0DA1-4B49-BA35-E12D666FF5DF',
  CanEditCapacityOwner: '694EFF24-3323-4A29-8C37-F49C2D50641B',
};

export const FeatureFlagValues = {
  CarrierVerificationLockdown: true,
  HighwayUpdateInsurance: false,
};

export const SidebarDataStore = {
  annoucementsData: {
    loading: false,
    data: [],
  },
  pendingCustomers: {
    loading: false,
    data: [],
  },
  doNotSolicitRequests: {
    loading: false,
    data: [],
  },
  creditIncreaseRequestCustomers: {
    loading: false,
    data: [],
  },
  escalations: {
    loading: false,
    data: [],
  },
  pendingChecksData: {
    loading: false,
    data: [],
  },
  maxRateRequestsData: {
    loading: false,
    data: [],
  },
  needPaperworkData: {
    loading: false,
    data: [],
  },
  alertsData: {
    loading: false,
    data: [],
  },
  approvalsData: {
    loading: false,
    loaded: false,
    allApprovals: [],
    disputedLoads: [],
    approvalGrouping: {},
    disputedGrouping: {},
  },
  overdueApprovals: {
    loading: false,
    data: [],
  },
  approvals: {
    loading: false,
    data: [],
  },
  isCollapsed: true,
};

export const WarningDataStore = {
  billingHolds: {
    loading: false,
    data: [],
  },
  oldLoad: {
    loading: false,
    data: {
      data: [],
      totalCount: 0,
    },
  },
  warningComponent: {
    height: 0,
    visible: false,
  },
};
